import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "../config";
import { useAuth } from "../context/AuthContext";

async function fetchWithAuth(url, options = {}, token) {
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, { ...options, headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Request failed");
  }

  return data;
}

export function useRegister() {
  const { login } = useAuth();

  return useMutation({
    mutationFn: async ({ email, password, firstName, lastName }) => {
      return fetchWithAuth(`${API_BASE_URL}/api/v1/auth/register`, {
        method: "POST",
        body: JSON.stringify({ email, password, firstName, lastName }),
      });
    },
    onSuccess: (data) => {
      if (data.success) {
        login(data.user, data.token);
      }
    },
  });
}

export function useLogin() {
  const { login } = useAuth();

  return useMutation({
    mutationFn: async ({ email, password }) => {
      return fetchWithAuth(`${API_BASE_URL}/api/v1/auth/login`, {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
    },
    onSuccess: (data) => {
      if (data.success) {
        login(data.user, data.token);
      }
    },
  });
}

export function useLogout() {
  const { token, logout } = useAuth();

  return useMutation({
    mutationFn: async () => {
      return fetchWithAuth(
        `${API_BASE_URL}/api/v1/auth/logout`,
        { method: "POST" },
        token
      );
    },
    onSuccess: () => {
      logout();
    },
    onError: () => {
      logout();
    },
  });
}

export function useCurrentUser() {
  const { token, isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ["currentUser"],
    queryFn: () => fetchWithAuth(`${API_BASE_URL}/api/v1/auth/me`, {}, token),
    enabled: isAuthenticated,
    retry: false,
  });
}

